// This is the white bar that goes the width of the screen and lets you select a current league
import React, { useState, useEffect } from 'react'
import Card from './Card'
import './SelectLeague.css'
import { useNavigate } from 'react-router-dom'

const SelectLeague = () => {
	console.log('inside SelectLeague.js')

	const [isLoading, setIsLoading] = useState(false)
	const [leaguesNoDuplicates, setLeaguesNoDuplicates] = useState()
	const [error, setError] = useState()

	const navigate = useNavigate()

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)

			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/leagues/current',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setLeaguesNoDuplicates(responseData.currentLeaguesSortedNoDuplicates)
			} catch (err) {
				setError(err.message)
			}

			setIsLoading(false)
		}

		sendRequest()
	}, [])

	const handleChange = (e) => {
		const selectedValue = e.target.value

		if (selectedValue === 'VIEW PREVIOUS TOURNAMENTS') {
			navigate('/league/previousLeagues')
			return
		}

		if (selectedValue === 'Select Tournament....') {
			return
		}

		const selectedLeague = leaguesNoDuplicates[selectedValue]
		const leagueId = selectedLeague._id

		navigate(`/league/${leagueId}`)
	}

	const leaguesNoDuplicatesArray = []

	if (leaguesNoDuplicates && !isLoading) {
		leaguesNoDuplicates.forEach((league) => {
			const leagueDisplay = league.leagueName + ' - ' + league.year
			leaguesNoDuplicatesArray.push(leagueDisplay)
		})
	}

	return (
		<React.Fragment>
			<Card>
				{!isLoading && leaguesNoDuplicates && (
					<div className='scoringLeagueSelectorTop'>
						<form className='form-control-lg scoringLeagueSelectorForm'>
							<select
								className='selector my-1 mr-sm-2 selectLeagueDropdown scoringLeagueDropdown'
								onChange={handleChange}
							>
								<option defaultValue>Select Tournament....</option>

								{leaguesNoDuplicatesArray.map((league, i) => (
									<option value={i} key={i}>
										{league.toUpperCase()}
									</option>
								))}

								<option style={{ background: '#b42328' }}>
									VIEW PREVIOUS TOURNAMENTS
								</option>
							</select>
						</form>
					</div>
				)}
			</Card>
		</React.Fragment>
	)
}

export default SelectLeague
